// @flow
import SubLayout11 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-1-1';
import SubLayout12 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-1-2';
import SubLayout13 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-1-3';
import SubLayout14 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-1-4';
import SubLayout21 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-1';
import SubLayout22 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-2';
import SubLayout23 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-3';
import SubLayout24 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-4';
import SubLayout25 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-5';
import SubLayout26 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-6';
import SubLayout27 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-7';
import SubLayout28 from 'src/components/views/theme-settings/layout-modal/product-item-tab/sub-layout-2-8';
import CollectionHeader1 from 'src/components/views/theme-settings/layout-modal/collection-header-tab/collection-header-1';
import CollectionHeader2 from 'src/components/views/theme-settings/layout-modal/collection-header-tab/collection-header-2';
import CollectionHeader3 from 'src/components/views/theme-settings/layout-modal/collection-header-tab/collection-header-3';
import CollectionHeader4 from 'src/components/views/theme-settings/layout-modal/collection-header-tab/collection-header-4';

export const PAGE_LAYOUT_TYPE = [
  { value: 'box', label: 'AdminHTML.DefaultThemeSettings.Constants.pageLayoutType01_Label' },
  { value: 'fullwidth', label: 'AdminHTML.DefaultThemeSettings.Constants.pageLayoutType02_Label' }
];

export const VIEW_AS_TYPE = [
  {
    value: 'view_as_type_grid_list',
    label: 'AdminHTML.DefaultThemeSettings.Constants.viewAsType01_Label'
  },
  {
    value: 'view_as_type_list_grid_multi_col',
    label: 'AdminHTML.DefaultThemeSettings.Constants.viewAsType02_Label'
  }
];

export const PRODUCT_ITEM_TYPE = [
  { value: 'grid', label: 'AdminHTML.DefaultThemeSettings.Constants.productItemType01_Label' },
  { value: 'list', label: 'AdminHTML.DefaultThemeSettings.Constants.productItemType02_Label' }
];

export const PRODUCT_ITEM_LAYOUT = [
  {
    value: 'no-border',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productItemLayout01_Label'
  },
  {
    value: 'border-no-padding',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productItemLayout02_Label'
  },
  {
    value: 'border-no-padding-img',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productItemLayout03_Label'
  },
  {
    value: 'border-has-padding',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productItemLayout04_Label'
  }
];

export const TEXT_ALIGNMENT = [
  {
    value: 'left',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textAlignment01_Label'
  },
  {
    value: 'center',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textAlignment02_Label'
  },
  {
    value: 'right',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textAlignment03_Label'
  }
];

export const ASPECT_RATIO = [
  {
    value: 'false',
    label: 'AdminHTML.DefaultThemeSettings.Constants.aspectRatio01_Label'
  },
  {
    value: 'auto',
    label: 'AdminHTML.DefaultThemeSettings.Constants.aspectRatio02_Label'
  },
  {
    value: '1:1',
    label: 'AdminHTML.DefaultThemeSettings.Constants.aspectRatio03_Label'
  },
  {
    value: '2:3',
    label: 'AdminHTML.DefaultThemeSettings.Constants.aspectRatio04_Label'
  },
  {
    value: '4:3',
    label: 'AdminHTML.DefaultThemeSettings.Constants.aspectRatio05_Label'
  },
  {
    value: 'other',
    label: 'AdminHTML.DefaultThemeSettings.Constants.aspectRatio06_Label'
  }
];

export const PRODUCT_IMAGE_CROP = [
  {
    value: 'none',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textTransform01_Label'
  },
  {
    value: 'top',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productImageCrop02_Label'
  },
  {
    value: 'center',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productImageCrop03_Label'
  },
  {
    value: 'bottom',
    label: 'AdminHTML.DefaultThemeSettings.Constants.productImageCrop04_Label'
  }
];

export const TEXT_TRANSFORM = [
  {
    value: 'none',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textTransform01_Label'
  },
  {
    value: 'uppercase',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textTransform02_Label'
  },
  {
    value: 'capitalize',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textTransform03_Label'
  },
  {
    value: 'lowercase',
    label: 'AdminHTML.DefaultThemeSettings.Constants.textTransform04_Label'
  }
];

export const SWATCH_CHANGE_IMAGE = [
  {
    value: 'none',
    label: 'AdminHTML.DefaultThemeSettings.Constants.swatchChangeImage01_Label'
  },
  {
    value: 'hover',
    label: 'AdminHTML.DefaultThemeSettings.Constants.swatchChangeImage02_Label'
  },
  {
    value: 'click',
    label: 'AdminHTML.DefaultThemeSettings.Constants.swatchChangeImage03_Label'
  }
];

export const SWATCH_SHAPE = [
  {
    value: 'circle',
    label: 'AdminHTML.DefaultThemeSettings.Constants.swatchShape01_Label'
  },
  {
    value: 'square',
    label: 'AdminHTML.DefaultThemeSettings.Constants.swatchShape02_Label'
  }
];

export const LABEL_POSITION = [
  {
    value: 'top_left',
    label: 'AdminHTML.DefaultThemeSettings.Constants.labelPosition01_Label'
  },
  {
    value: 'top_right',
    label: 'AdminHTML.DefaultThemeSettings.Constants.labelPosition02_Label'
  },
  {
    value: 'bottom_left',
    label: 'AdminHTML.DefaultThemeSettings.Constants.labelPosition03_Label'
  },
  {
    value: 'bottom_right',
    label: 'AdminHTML.DefaultThemeSettings.Constants.labelPosition04_Label'
  }
];

export const LABEL_TYPE = [
  {
    value: 'rectangle',
    label: 'AdminHTML.DefaultThemeSettings.Constants.labelType01_Label'
  },
  {
    value: 'circle',
    label: 'AdminHTML.DefaultThemeSettings.Constants.labelType02_Label'
  }
];

export const SALE_LABEL_DISPLAY = [
  {
    value: 'text',
    label: 'AdminHTML.DefaultThemeSettings.Constants.saleLabelDisplay01_Label'
  },
  {
    value: 'sale_percent',
    label: 'AdminHTML.DefaultThemeSettings.Constants.saleLabelDisplay02_Label'
  },
  {
    value: 'image',
    label: 'AdminHTML.DefaultThemeSettings.Constants.saleLabelDisplay03_Label'
  }
];

export const SOLD_OUT_LABEL_DISPLAY = [
  {
    value: 'text',
    label: 'AdminHTML.DefaultThemeSettings.Constants.soldOutLabelDisplay01_Label'
  },
  {
    value: 'image',
    label: 'AdminHTML.DefaultThemeSettings.Constants.soldOutLabelDisplay02_Label'
  }
];

// New theme setting ----------------
export const DEVICE = {
  DESKTOP: 0,
  MOBILE: 1,
  FULLSCREEN: 2
};

export const PAGES = {
  COLLECTION: 'collections',
  SEARCH: 'search',
  ISW: 'instant-search-widget',
  RECOMMENDATION: 'recommendation'
};

export const PAGES_SHOPIFY_INTEGRATION = {
  COLLECTION: 'collection_page',
  SEARCH: 'search_page',
  ISW: 'instant-search-widget',
  RECOMMENDATION: 'recommendation'
};

// For update setting in specific menu
export const TYPE_UPDATE_SETTING = {
  COLLECTION: 'collection',
  SEARCH: 'search',
  COMMON: 'common'
};

export const PREVIEW_PAGES = [
  {
    label: 'AdminHTML.ThemeSetting.Common.collectionPage',
    value: PAGES.COLLECTION
  },
  {
    label: 'AdminHTML.ThemeSetting.Common.searchPage',
    value: PAGES.SEARCH
  }
  // {
  //   label: 'AdminHTML.ThemeSetting.Common.instantSearch',
  //   value: PAGES.ISW
  // },
  // {
  //   label: 'AdminHTML.ThemeSetting.Common.recommendation',
  //   value: PAGES.RECOMMENDATION
  // }
];

export const PREVIEW_PAGES_SHOPIFY_INTEGRATION = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.collectionPage',
    value: PAGES_SHOPIFY_INTEGRATION.COLLECTION
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Common.searchPage',
    value: PAGES_SHOPIFY_INTEGRATION.SEARCH
  }
];

export const ELEMENTS = {
  // Product image
  PRODUCT_IMAGE_SOLD_OUT_LABEL: 'productImage_productSoldOutLabel',
  PRODUCT_IMAGE_TOP_SOLD_OUT_LABEL: 'productImageTop_productSoldOutLabel',
  PRODUCT_IMAGE_MIDDLE_SOLD_OUT_LABEL: 'productImageMiddle_productSoldOutLabel',
  PRODUCT_IMAGE_BOTTOM_SOLD_OUT_LABEL: 'productImageBottom_productSoldOutLabel',

  PRODUCT_IMAGE_SALE_LABEL: 'productImage_productSaleLabel',
  PRODUCT_IMAGE_TOP_SALE_LABEL: 'productImageTop_productSaleLabel',
  PRODUCT_IMAGE_MIDDLE_SALE_LABEL: 'productImageMiddle_productSaleLabel',
  PRODUCT_IMAGE_BOTTOM_SALE_LABEL: 'productImageBottom_productSaleLabel',

  PRODUCT_IMAGE_CUSTOM_BY_TAG_LABEL: 'productImage_productCustomLabelByTag',
  PRODUCT_IMAGE_TOP_CUSTOM_BY_TAG_LABEL: 'productImageTop_productCustomLabelByTag',
  PRODUCT_IMAGE_MIDDLE_CUSTOM_BY_TAG_LABEL: 'productImageMiddle_productCustomLabelByTag',
  PRODUCT_IMAGE_BOTTOM_CUSTOM_BY_TAG_LABEL: 'productImageBottom_productCustomLabelByTag',

  PRODUCT_IMAGE_RATING: 'productImage_rating',
  PRODUCT_IMAGE_TOP_RATING: 'productImageTop_rating',
  PRODUCT_IMAGE_MIDDLE_RATING: 'productImageMiddle_rating',
  PRODUCT_IMAGE_BOTTOM_RATING: 'productImageBottom_rating',

  PRODUCT_IMAGE_SWATCH_ITEM_1: 'productImage_swatches-1',
  PRODUCT_IMAGE_SWATCH_ITEM_2: 'productImage_swatches-2',
  PRODUCT_IMAGE_SWATCH_ITEM_3: 'productImage_swatches-3',
  PRODUCT_IMAGE_BUTTON_1: 'productImage_button1',
  PRODUCT_IMAGE_BUTTON_2: 'productImage_button2',
  PRODUCT_IMAGE_TOP_SWATCH_ITEM_1: 'productImageTop_swatches-1',
  PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_1: 'productImageMiddle_swatches-1',
  PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_1: 'productImageBottom_swatches-1',
  PRODUCT_IMAGE_TOP_SWATCH_ITEM_2: 'productImageTop_swatches-2',
  PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_2: 'productImageMiddle_swatches-2',
  PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_2: 'productImageBottom_swatches-2',
  PRODUCT_IMAGE_TOP_SWATCH_ITEM_3: 'productImageTop_swatches-3',
  PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_3: 'productImageMiddle_swatches-3',
  PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_3: 'productImageBottom_swatches-3',
  PRODUCT_IMAGE_TOP_BUTTON_1: 'productImageTop_button1',
  PRODUCT_IMAGE_MIDDLE_BUTTON_1: 'productImageMiddle_button1',
  PRODUCT_IMAGE_BOTTOM_BUTTON_1: 'productImageBottom_button1',
  PRODUCT_IMAGE_TOP_BUTTON_2: 'productImageTop_button2',
  PRODUCT_IMAGE_MIDDLE_BUTTON_2: 'productImageMiddle_button2',
  PRODUCT_IMAGE_BOTTOM_BUTTON_2: 'productImageBottom_button2',

  // Product information
  PRODUCT_INFORMATION_PRODUCT_TITLE: 'productInformation_productTitle',
  PRODUCT_INFORMATION_PRODUCT_PRICE: 'productInformation_productPrice',
  PRODUCT_INFORMATION_PRODUCT_VENDOR: 'productInformation_productVendor',
  PRODUCT_INFORMATION_RATING: 'productInformation_rating',
  PRODUCT_INFORMATION_INVENTORY_STATUS: 'productInformation_inventoryStatus',
  PRODUCT_INFORMATION_DESCRIPTION: 'productInformation_productDescription',
  PRODUCT_INFORMATION_WISHLIST: 'productInformation_wishlist',

  PRODUCT_INFORMATION_SWATCH_ITEM_1: 'productInformation_swatches-1',
  PRODUCT_INFORMATION_SWATCH_ITEM_2: 'productInformation_swatches-2',
  PRODUCT_INFORMATION_SWATCH_ITEM_3: 'productInformation_swatches-3',
  PRODUCT_INFORMATION_BUTTON_1: 'productInformation_button1',
  PRODUCT_INFORMATION_BUTTON_2: 'productInformation_button2',

  COLLECTION_HEADER_IMAGE: 'collectionHeader_collectionImage',
  COLLECTION_HEADER_TITLE: 'collectionHeader_collectionTitle',
  COLLECTION_HEADER_DESCRIPTION: 'collectionHeader_collectionDescription',
  COLLECTION_HEADER_PRODUCT_COUNT: 'collectionHeader_productCount',
  COLLECTION_HEADER_BREADCRUMBS: 'collectionHeader_breadCrumb',

  TOOLBAR_VIEW_AS: 'toolbar_viewAs',
  TOOLBAR_PRODUCT_COUNT: 'toolbar_productCount',
  TOOLBAR_SHOW_LIMIT: 'toolbar_showLimitList',
  TOOLBAR_SORT_BY: 'toolbar_sorting',

  COLOR_BASE_1: 'baseColor1',
  COLOR_BASE_2: 'baseColor2',
  COLOR_BASE_3: 'baseColor3',
  COLOR_BASE_4: 'baseColor4',
  COLOR_BASE_5: 'baseColor5',
  ACCENT_BASE_1: 'accentColor1',
  ACCENT_BASE_2: 'accentColor2',
  ACCENT_BASE_3: 'accentColor3',
  ACCENT_BASE_4: 'accentColor4',
  ADVANCED_COLOR: 'advancedSettings',
  ADVANCED_COLOR_GENERAL_BACKGROUND: 'colors.advancedSettings.block.background',
  ADVANCED_COLOR_GENERAL_PRODUCT_ITEM_BACKGROUND:
    'colors.advancedSettings.block.productItemBackground',
  ADVANCED_COLOR_GENERAL_LINE_DIVIDER: 'colors.advancedSettings.block.lineDividers',

  ADVANCED_COLOR_BUTTON_BACKGROUND: 'colors.advancedSettings.button.background',
  ADVANCED_COLOR_BUTTON_OUTLINE: 'colors.advancedSettings.button.outline',
  ADVANCED_COLOR_BUTTON_TEXT: 'colors.advancedSettings.button.text',
  ADVANCED_COLOR_SECONDARY_BUTTON_BACKGROUND:
    'colors.advancedSettings.button.secondaryButtonBackground',

  ADVANCED_COLOR_TEXT_HEADING: 'colors.advancedSettings.text.heading',
  ADVANCED_COLOR_TEXT_SUBTITLE: 'colors.advancedSettings.text.labelText',
  ADVANCED_COLOR_TEXT_BODY_TEXT: 'colors.advancedSettings.text.bodyText',
  ADVANCED_COLOR_TEXT_SECONDARY_TEXT: 'colors.advancedSettings.text.secondaryText',
  ADVANCED_COLOR_TEXT_LINK_ACTIONS: 'colors.advancedSettings.text.linkAction',

  ADVANCED_COLOR_OTHER_PRODUCT_PRICE: 'colors.advancedSettings.productPrice.priceColor',
  ADVANCED_COLOR_OTHER_SALE_PRICE: 'colors.advancedSettings.productPrice.salePriceColor',
  ADVANCED_COLOR_OTHER_COMPARE_AT_PRICE: 'colors.advancedSettings.productPrice.compareAtPriceColor',
  ADVANCED_COLOR_OTHER_SAVING_TEXT_PRICE: 'colors.advancedSettings.productPrice.savingTextColor',
  ADVANCED_COLOR_OTHER_SALE_LABEL: 'colors.advancedSettings.others.saleLabelColor',
  ADVANCED_COLOR_OTHER_SOLD_OUT_LABEL: 'colors.advancedSettings.others.soldOutLabelColor',
  ADVANCED_COLOR_OTHER_CUSTOM_BY_TAG_LABEL: 'colors.advancedSettings.others.customByTagLabelColor',
  ADVANCED_COLOR_OTHER_IN_STOCK: 'colors.advancedSettings.others.inStockColor',
  ADVANCED_COLOR_OTHER_LOW_STOCK: 'colors.advancedSettings.others.lowStockColor',
  ADVANCED_COLOR_OTHER_OUT_OF_STOCK: 'colors.advancedSettings.others.outOfStockColor',

  TYPOGRAPHY_HEADING: 'typography.headings',
  TYPOGRAPHY_BODY: 'typography.body',
  TYPOGRAPHY_BUTTON: 'typography.buttons',
  TYPOGRAPHY_LINK_ACCENT: 'typography.linkAccent',

  PREVIEW: 'preview'
};

export const MAP_ELEMENT_LABEL = {
  // Product image
  [ELEMENTS.PRODUCT_IMAGE_SOLD_OUT_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SoldOutLabel',
  [ELEMENTS.PRODUCT_IMAGE_TOP_SOLD_OUT_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SoldOutLabel',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SOLD_OUT_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SoldOutLabel',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SOLD_OUT_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SoldOutLabel',

  [ELEMENTS.PRODUCT_IMAGE_SALE_LABEL]: 'AdminHTML.ThemeSetting.Elements.elementOption_SaleLabel',
  [ELEMENTS.PRODUCT_IMAGE_TOP_SALE_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SaleLabel',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SALE_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SaleLabel',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SALE_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SaleLabel',

  [ELEMENTS.PRODUCT_IMAGE_CUSTOM_BY_TAG_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CustomTagLabel',
  [ELEMENTS.PRODUCT_IMAGE_TOP_CUSTOM_BY_TAG_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CustomTagLabel',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_CUSTOM_BY_TAG_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CustomTagLabel',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_CUSTOM_BY_TAG_LABEL]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CustomTagLabel',

  [ELEMENTS.PRODUCT_IMAGE_RATING]: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',
  [ELEMENTS.PRODUCT_IMAGE_TOP_RATING]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_RATING]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_RATING]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',

  [ELEMENTS.PRODUCT_IMAGE_SWATCH_ITEM_1]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',
  [ELEMENTS.PRODUCT_IMAGE_TOP_SWATCH_ITEM_1]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_1]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_1]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',

  [ELEMENTS.PRODUCT_IMAGE_SWATCH_ITEM_2]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',
  [ELEMENTS.PRODUCT_IMAGE_TOP_SWATCH_ITEM_2]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_2]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_2]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',

  [ELEMENTS.PRODUCT_IMAGE_SWATCH_ITEM_3]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',
  [ELEMENTS.PRODUCT_IMAGE_TOP_SWATCH_ITEM_3]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_3]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_3]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',

  [ELEMENTS.PRODUCT_IMAGE_BUTTON_1]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',
  [ELEMENTS.PRODUCT_IMAGE_TOP_BUTTON_1]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_BUTTON_1]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_BUTTON_1]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',

  [ELEMENTS.PRODUCT_IMAGE_BUTTON_2]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',
  [ELEMENTS.PRODUCT_IMAGE_TOP_BUTTON_2]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',
  [ELEMENTS.PRODUCT_IMAGE_MIDDLE_BUTTON_2]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',
  [ELEMENTS.PRODUCT_IMAGE_BOTTOM_BUTTON_2]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',

  // Product information
  [ELEMENTS.PRODUCT_INFORMATION_PRODUCT_TITLE]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductTitle',
  [ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductPrice',
  [ELEMENTS.PRODUCT_INFORMATION_PRODUCT_VENDOR]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductVendor',
  [ELEMENTS.PRODUCT_INFORMATION_RATING]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',
  [ELEMENTS.PRODUCT_INFORMATION_INVENTORY_STATUS]:
    'AdminHTML.ThemeSetting.Elements.elementOption_InventoryStatus',
  [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_1]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',
  [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_2]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',
  [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_3]:
    'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',
  [ELEMENTS.PRODUCT_INFORMATION_BUTTON_1]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',
  [ELEMENTS.PRODUCT_INFORMATION_BUTTON_2]: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',
  [ELEMENTS.PRODUCT_INFORMATION_WISHLIST]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductWishlist',

  [ELEMENTS.COLLECTION_HEADER_IMAGE]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Image',
  [ELEMENTS.COLLECTION_HEADER_TITLE]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Title',
  [ELEMENTS.COLLECTION_HEADER_DESCRIPTION]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Description',
  [ELEMENTS.COLLECTION_HEADER_PRODUCT_COUNT]:
    'AdminHTML.ThemeSetting.Elements.elementOption_ProductCount',
  [ELEMENTS.COLLECTION_HEADER_BREADCRUMBS]:
    'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Breadcrumbs',

  [ELEMENTS.TOOLBAR_VIEW_AS]: 'AdminHTML.ThemeSetting.Elements.elementOption_ViewAs',
  [ELEMENTS.TOOLBAR_PRODUCT_COUNT]: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductCount',
  [ELEMENTS.TOOLBAR_SHOW_LIMIT]: 'AdminHTML.ThemeSetting.Elements.elementOption_ShowLimit',
  [ELEMENTS.TOOLBAR_SORT_BY]: 'AdminHTML.ThemeSetting.Elements.elementOption_SortBy'
};

export const PRODUCT_IMAGE_ELEMENTS_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SaleLabel',
    value: ELEMENTS.PRODUCT_IMAGE_SALE_LABEL
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SoldOutLabel',
    value: ELEMENTS.PRODUCT_IMAGE_SOLD_OUT_LABEL
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_CustomTagLabel',
    value: ELEMENTS.PRODUCT_IMAGE_CUSTOM_BY_TAG_LABEL
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',
    value: ELEMENTS.PRODUCT_IMAGE_RATING
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',
    value: ELEMENTS.PRODUCT_IMAGE_SWATCH_ITEM_1
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',
    value: ELEMENTS.PRODUCT_IMAGE_SWATCH_ITEM_2
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',
    value: ELEMENTS.PRODUCT_IMAGE_SWATCH_ITEM_3
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',
    value: ELEMENTS.PRODUCT_IMAGE_BUTTON_1
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',
    value: ELEMENTS.PRODUCT_IMAGE_BUTTON_2
  }
];

export const PRODUCT_INFORMATION_ELEMENTS = [
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductTitle',
    value: ELEMENTS.PRODUCT_INFORMATION_PRODUCT_TITLE
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductPrice',
    value: ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductVendor',
    value: ELEMENTS.PRODUCT_INFORMATION_PRODUCT_VENDOR
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductRating',
    value: ELEMENTS.PRODUCT_INFORMATION_RATING
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_InventoryStatus',
    value: ELEMENTS.PRODUCT_INFORMATION_INVENTORY_STATUS
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem1',
    value: ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_1
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem2',
    value: ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_2
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SwatchItem3',
    value: ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_3
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_Button1',
    value: ELEMENTS.PRODUCT_INFORMATION_BUTTON_1
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_Button2',
    value: ELEMENTS.PRODUCT_INFORMATION_BUTTON_2
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductWishlist',
    value: ELEMENTS.PRODUCT_INFORMATION_WISHLIST
  }
];

export const COLLECTION_HEADER_ELEMENTS = [
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Image',
    value: ELEMENTS.COLLECTION_HEADER_IMAGE
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Title',
    value: ELEMENTS.COLLECTION_HEADER_TITLE
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Description',
    value: ELEMENTS.COLLECTION_HEADER_DESCRIPTION
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductCount',
    value: ELEMENTS.COLLECTION_HEADER_PRODUCT_COUNT
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_CollectionHeader_Breadcrumbs',
    value: ELEMENTS.COLLECTION_HEADER_BREADCRUMBS
  }
];

export const TOOLBAR_ELEMENTS = [
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ViewAs',
    value: ELEMENTS.TOOLBAR_VIEW_AS
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ProductCount',
    value: ELEMENTS.TOOLBAR_PRODUCT_COUNT
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_ShowLimit',
    value: ELEMENTS.TOOLBAR_SHOW_LIMIT
  },
  {
    label: 'AdminHTML.ThemeSetting.Elements.elementOption_SortBy',
    value: ELEMENTS.TOOLBAR_SORT_BY
  }
];

export const PRODUCT_ITEM_BORDER_LAYOUT_VALUE = {
  NO_BORDER: 'noBorder',
  NO_PADDING: 'noPadding',
  NO_PADDING_IMAGE: 'noPaddingImage',
  HAS_PADDING: 'hasPadding'
};

export const PRODUCT_ITEM_BORDER_LAYOUT_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.productItem_BorderLayout_Option1',
    value: PRODUCT_ITEM_BORDER_LAYOUT_VALUE.NO_BORDER
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productItem_BorderLayout_Option2',
    value: PRODUCT_ITEM_BORDER_LAYOUT_VALUE.NO_PADDING
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productItem_BorderLayout_Option3',
    value: PRODUCT_ITEM_BORDER_LAYOUT_VALUE.NO_PADDING_IMAGE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productItem_BorderLayout_Option4',
    value: PRODUCT_ITEM_BORDER_LAYOUT_VALUE.HAS_PADDING
  }
];

export const TEXT_TRANSFORM_VALUE = {
  NONE: 'none',
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase',
  CAPITALIZE: 'capitalize'
};
export const TEXT_TRANSFORM_OPTIONS = [
  {
    label: '-',
    value: TEXT_TRANSFORM_VALUE.NONE
  },
  {
    label: 'AG',
    value: TEXT_TRANSFORM_VALUE.UPPERCASE
  },
  {
    label: 'ag',
    value: TEXT_TRANSFORM_VALUE.LOWERCASE
  },
  {
    label: 'Ag',
    value: TEXT_TRANSFORM_VALUE.CAPITALIZE
  }
];

export const PRODUCT_PRICE_DISPLAY_STYLE_VALUE = {
  NONE: 'none',
  FROM_MIN_PRICE: 'From {{minPrice}}',
  MIN_TO_MAX_PRICE: '{{minPrice}} - {{maxPrice}}'
};
export const PRODUCT_PRICE_DISPLAY_STYLE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Common.none',
    value: PRODUCT_PRICE_DISPLAY_STYLE_VALUE.NONE
  },
  {
    format: 'label {{label2}}',
    label: 'AdminHTML.ThemeSetting.Form.productPrice_DisplayStyle_Option1_1',
    label2: 'AdminHTML.ThemeSetting.Form.productPrice_DisplayStyle_Option1_2',
    value: PRODUCT_PRICE_DISPLAY_STYLE_VALUE.FROM_MIN_PRICE
  },
  {
    format: '{{label}} - {{label2}}',
    label: 'AdminHTML.ThemeSetting.Form.productPrice_DisplayStyle_Option2_1',
    label2: 'AdminHTML.ThemeSetting.Form.productPrice_DisplayStyle_Option2_2',
    value: PRODUCT_PRICE_DISPLAY_STYLE_VALUE.MIN_TO_MAX_PRICE
  }
];

export const PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE = {
  RIGHT: 'right',
  LEFT: 'left',
  TOP: 'top',
  BOTTOM: 'bottom'
};
export const PRODUCT_COMPARE_AT_PRICE_POSITION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.productPrice_CompareAtPricePosition_Option1',
    value: PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.RIGHT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productPrice_CompareAtPricePosition_Option2',
    value: PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productPrice_CompareAtPricePosition_Option3',
    value: PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.TOP
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productPrice_CompareAtPricePosition_Option4',
    value: PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.BOTTOM
  }
];

export const SWATCH_BY_VALUE = {
  COLOR: 'color',
  IMAGE: 'image',
  PRODUCT_IMAGE: 'product-image',
  TEXT: 'text',
  COLOR_AND_IMAGE: 'color-and-image',
};
export const SWATCH_BY_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option1',
    value: SWATCH_BY_VALUE.COLOR
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option2',
    value: SWATCH_BY_VALUE.TEXT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option3',
    value: SWATCH_BY_VALUE.IMAGE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option4',
    value: SWATCH_BY_VALUE.PRODUCT_IMAGE
  }
];
export const SWATCH_BY_OPTIONS_SI = [
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option2',
    value: SWATCH_BY_VALUE.TEXT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option5',
    value: SWATCH_BY_VALUE.COLOR_AND_IMAGE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_By_Option4',
    value: SWATCH_BY_VALUE.PRODUCT_IMAGE
  }
];

export const CHANGE_PRODUCT_IMAGE_WHEN_ACTION_VALUE = {
  NONE: 'none',
  HOVER: 'hover',
  CLICK: 'click'
};
export const CHANGE_PRODUCT_IMAGE_WHEN_ACTION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_ChangeProductImageAction_Option1',
    value: CHANGE_PRODUCT_IMAGE_WHEN_ACTION_VALUE.NONE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_ChangeProductImageAction_Option2',
    value: CHANGE_PRODUCT_IMAGE_WHEN_ACTION_VALUE.HOVER
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_ChangeProductImageAction_Option3',
    value: CHANGE_PRODUCT_IMAGE_WHEN_ACTION_VALUE.CLICK
  }
];

export const SWATCH_BUTTON_STYLE_VALUE = {
  COUNT: '+{{count}}',
  COUNT_MORE: '+{{count}} more'
};
export const SWATCH_BUTTON_STYLE_OPTIONS = [
  {
    format: `+{{label}}`,
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_MoreText_Filled1',
    value: SWATCH_BUTTON_STYLE_VALUE.COUNT
  },
  {
    format: `+{{label}} label2`,
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_MoreText_Filled1',
    label2: 'AdminHTML.ThemeSetting.Form.swatchItem_MoreText_Filled2',
    value: SWATCH_BUTTON_STYLE_VALUE.COUNT_MORE
  }
];

export const SHAPE_VALUE = {
  SQUARE: 'box',
  CIRCLE: 'circle'
};
export const SWATCH_SHAPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_Shape_Option1',
    value: SHAPE_VALUE.SQUARE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.swatchItem_Shape_Option2',
    value: SHAPE_VALUE.CIRCLE
  }
];

export const PRODUCT_IMAGE_RATIO_VALUE = {
  AUTO: 'auto',
  NATURAL: 'natural',
  SQUARE: 'square',
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
  MANUAL: 'manual'
};
export const PRODUCT_IMAGE_RATIO_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_Ratio_Option1',
    value: PRODUCT_IMAGE_RATIO_VALUE.AUTO
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_Ratio_Option2',
    value: PRODUCT_IMAGE_RATIO_VALUE.NATURAL
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_Ratio_Option3',
    value: PRODUCT_IMAGE_RATIO_VALUE.SQUARE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_Ratio_Option4',
    value: PRODUCT_IMAGE_RATIO_VALUE.PORTRAIT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_Ratio_Option5',
    value: PRODUCT_IMAGE_RATIO_VALUE.LANDSCAPE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_Ratio_Option6',
    value: PRODUCT_IMAGE_RATIO_VALUE.MANUAL
  }
];

export const PRODUCT_IMAGE_CROP_IMAGE_POSITION_VALUE = {
  NONE: 'none',
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom'
};
export const PRODUCT_IMAGE_CROP_IMAGE_POSITION_OPTIONS = [
  // {
  //   label: 'AdminHTML.ThemeSetting.Form.productImage_CropImagePosition_Option1',
  //   value: PRODUCT_IMAGE_CROP_IMAGE_POSITION_VALUE.NONE
  // },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_CropImagePosition_Option2',
    value: PRODUCT_IMAGE_CROP_IMAGE_POSITION_VALUE.TOP
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_CropImagePosition_Option3',
    value: PRODUCT_IMAGE_CROP_IMAGE_POSITION_VALUE.CENTER
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_CropImagePosition_Option4',
    value: PRODUCT_IMAGE_CROP_IMAGE_POSITION_VALUE.BOTTOM
  }
];

export const PRODUCT_IMAGE_HOVER_EFFECT_VALUE = {
  NONE: 'none',
  HOVER: 'reveal-second-image',
  ZOOM_IN: 'zoom-in',
  HOVER_ZOOM_IN: 'reveal-second-image-and-zoom-in'
};
export const PRODUCT_IMAGE_HOVER_EFFECT_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_HoverEffect_Option1',
    value: PRODUCT_IMAGE_HOVER_EFFECT_VALUE.NONE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_HoverEffect_Option2',
    value: PRODUCT_IMAGE_HOVER_EFFECT_VALUE.HOVER
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_HoverEffect_Option3',
    value: PRODUCT_IMAGE_HOVER_EFFECT_VALUE.ZOOM_IN
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImage_HoverEffect_Option4',
    value: PRODUCT_IMAGE_HOVER_EFFECT_VALUE.HOVER_ZOOM_IN
  }
];

export const PRODUCT_IMAGE_AREA_ARRANGEMENT_VALUE = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
export const PRODUCT_IMAGE_AREA_ARRANGEMENT_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.productImageArea_Arrangement_Option1',
    value: PRODUCT_IMAGE_AREA_ARRANGEMENT_VALUE.HORIZONTAL
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.productImageArea_Arrangement_Option2',
    value: PRODUCT_IMAGE_AREA_ARRANGEMENT_VALUE.VERTICAL
  }
];

export const LABEL_DISPLAY_VALUE = {
  ALWAYS_SHOW: 'always',
  SHOW_ON_HOVER: 'on-hover'
};

export const LABEL_DISPLAY_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_DisplayOption_AlwaysShow',
    value: LABEL_DISPLAY_VALUE.ALWAYS_SHOW
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productLabel_DisplayOption_ShowOnHover',
    value: LABEL_DISPLAY_VALUE.SHOW_ON_HOVER
  }
];

export const LABEL_SHAPE_VALUE = {
  RECTANGLE: 'rectangle',
  ROUNDED_RECTANGLE: 'rounded-rectangle',
  CIRCLE: 'circle',
  CAPSULE: 'capsule'
};

export const LABEL_SHAPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.saleLabel_Shape_Option1',
    value: LABEL_SHAPE_VALUE.RECTANGLE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.saleLabel_Shape_Option2',
    value: LABEL_SHAPE_VALUE.ROUNDED_RECTANGLE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.saleLabel_Shape_Option3',
    value: LABEL_SHAPE_VALUE.CIRCLE
  }
];

export const SOLD_OUT_LABEL_DISPLAY_VALUE = {
  TEXT: 'text',
  IMAGE: 'image'
};
export const SOLD_OUT_LABEL_DISPLAY_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.soldOutLabel_Display_Option1',
    value: SOLD_OUT_LABEL_DISPLAY_VALUE.TEXT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.soldOutLabel_Display_Option2',
    value: SOLD_OUT_LABEL_DISPLAY_VALUE.IMAGE
  }
];

export const SALE_LABEL_DISPLAY_VALUE = {
  SALE_LABEL_ONLY: 'sale-label-only',
  SALE_PRICE_LABEL_ONLY: 'sale-price-label-only',
  SALE_PRICE_LABEL_AND_SALE_LABEL: 'sale-price-label-and-sale-label',
  TEXT: 'text',
  IMAGE: 'image'
};
export const SALE_LABEL_COLLAPSE_DISPLAY_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.saleLabel_Display_Option1',
    value: SALE_LABEL_DISPLAY_VALUE.TEXT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.saleLabel_Display_Option2',
    value: SALE_LABEL_DISPLAY_VALUE.IMAGE
  }
];

export const SHOW_BUTTON_VALUE = {
  DESKTOP_MOBILE: 'desktopAndMobile',
  DESKTOP: 'desktopOnly'
};
export const SHOW_BUTTON_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Show_Option1',
    value: SHOW_BUTTON_VALUE.DESKTOP_MOBILE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Show_Option2',
    value: SHOW_BUTTON_VALUE.DESKTOP
  }
];

export const BUTTON_STYLING_VALUE = {
  SOLID: 'solid',
  OUTLINE: 'outline'
};

export const BUTTON_STYLING_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_ButtonStyling_Solid',
    value: BUTTON_STYLING_VALUE.SOLID
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_ButtonStyling_Outline',
    value: BUTTON_STYLING_VALUE.OUTLINE
  }
];

export const BUTTON_TYPE_VALUE = {
  SELECTION_ADD_TO_CART: 'selectOptionBtn',
  QUICK_VIEW: 'qvBtn',
  VIEW_PRODUCT: 'goToDetailBtn'
};
export const BUTTON_TYPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Type_Option1',
    value: BUTTON_TYPE_VALUE.SELECTION_ADD_TO_CART
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Type_Option2',
    value: BUTTON_TYPE_VALUE.QUICK_VIEW
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Type_Option3',
    value: BUTTON_TYPE_VALUE.VIEW_PRODUCT
  }
];

export const SELECT_OPTIONS_ACTION_VALUE = {
  POPUP: 'popup',
  QUICK_ADD_TO_CART: 'quickAddToCart',
  PRODUCT_PAGE: 'productPage'
};
export const SELECT_OPTIONS_ACTION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_SelectOptionAction_Option1',
    value: SELECT_OPTIONS_ACTION_VALUE.POPUP
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_SelectOptionAction_Option2',
    value: SELECT_OPTIONS_ACTION_VALUE.QUICK_ADD_TO_CART
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_SelectOptionAction_Option3',
    value: SELECT_OPTIONS_ACTION_VALUE.PRODUCT_PAGE
  }
];

export const DISPLAY_TYPE_VALUE = {
  TEXT_ONLY: 'text',
  TEXT_ICON: 'textWithIcon',
  ICON_ONLY: 'icon'
};
export const DISPLAY_TYPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_DisplayType_Option1',
    value: DISPLAY_TYPE_VALUE.TEXT_ONLY
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_DisplayType_Option2',
    value: DISPLAY_TYPE_VALUE.TEXT_ICON
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_DisplayType_Option3',
    value: DISPLAY_TYPE_VALUE.ICON_ONLY
  }
];

export const BUTTON_SHAPE_VALUE = {
  CIRCLE: 'circle',
  SQUARE: 'square',
  RECTANGLE: 'rectangle',
  ROUNDED_RECTANGLE: 'round',
  CAPSULE: 'capsule',
  ROUNDED_SQUARE: 'rounded-square'
};
export const BUTTON_SHAPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Shape_Option1',
    value: BUTTON_SHAPE_VALUE.CIRCLE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Shape_Option2',
    value: BUTTON_SHAPE_VALUE.SQUARE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Shape_Option3',
    value: BUTTON_SHAPE_VALUE.RECTANGLE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Shape_Option4',
    value: BUTTON_SHAPE_VALUE.ROUNDED_RECTANGLE
  }
];

export const BUTTON_WIDTH_VALUE = {
  AUTO: '',
  FULL_WIDTH: '100%',
  HALF: '50%',
  MANUAL_CUSTOM: 'manual-custom'
};
export const BUTTON_WIDTH_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Dimension_ButtonWidth_Option1',
    value: BUTTON_WIDTH_VALUE.AUTO
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Dimension_ButtonWidth_Option2',
    value: BUTTON_WIDTH_VALUE.FULL_WIDTH
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Dimension_ButtonWidth_Option3',
    value: BUTTON_WIDTH_VALUE.HALF
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Dimension_ButtonWidth_Option4',
    value: BUTTON_WIDTH_VALUE.MANUAL_CUSTOM
  }
];
export const BUTTON_WIDTH_OPTIONS_V2 = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productButton_ButtonWidth_Option1',
    value: BUTTON_WIDTH_VALUE.AUTO
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productButton_ButtonWidth_Option2',
    value: BUTTON_WIDTH_VALUE.FULL_WIDTH
  }
];

export const WIDTH_UNIT_VALUE = {
  PERCENT: '%',
  PX: 'px'
};
export const WIDTH_UNIT_OPTIONS = [
  {
    label: '%',
    value: WIDTH_UNIT_VALUE.PERCENT
  },
  {
    label: 'px',
    value: WIDTH_UNIT_VALUE.PX
  }
];

export const BUTTON_DISPLAY_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productButton_DisplayOption_AlwaysShow',
    value: false
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productButton_DisplayOption_ShowOnHover',
    value: true
  }
];

export const ICON_POSITION_VALUE = {
  RIGHT: 'right',
  LEFT: 'left'
};
export const ICON_POSITION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_IconPosition_Option1',
    value: ICON_POSITION_VALUE.LEFT
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_IconPosition_Option2',
    value: ICON_POSITION_VALUE.RIGHT
  }
];

export const TEXT_DESCRIPTION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderProductCount_TextDescription_Option1',
    value: '{{count}} products'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderProductCount_TextDescription_Option2',
    value: 'Showing {{from}} - {{to}} of {{total}} products'
  }
];

export const BREADCRUMB_PLACEMENT_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_Placement_Item1',
    value: 'on-top'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderBreadcrumb_Placement_Item2',
    value: 'above-title'
  }
];

export const LAYOUT_OPTIONS = [
  { label: 'AdminHTML.ThemeSetting.Form.collectionHeader_Layout_Option1', value: 'layout-1' },
  { label: 'AdminHTML.ThemeSetting.Form.collectionHeader_Layout_Option2', value: 'layout-2' },
  { label: 'AdminHTML.ThemeSetting.Form.collectionHeader_Layout_Option3', value: 'layout-3' },
  { label: 'AdminHTML.ThemeSetting.Form.collectionHeader_Layout_Option4', value: 'layout-4' }
];

export const IMAGE_SIZE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderImage_Size_Option1',
    value: 'small',
    helpText: 'Desktop: 420px, mobile: 280 px'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderImage_Size_Option2',
    value: 'medium',
    helpText: 'Desktop: 560 px, mobile: 340 px'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderImage_Size_Option3',
    value: 'large',
    helpText: 'Desktop: 720 px, mobile: 390 px'
  },
  { label: 'AdminHTML.ThemeSetting.Form.collectionHeaderImage_Size_Option4', value: 'original' }
];

export const PARALLAX_DIRECTION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderImage_Direction_Option1',
    value: 'horizontal'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.collectionHeaderImage_Direction_Option2',
    value: 'vertical'
  }
];

export const MAIN_LAYOUT_VALUE = {
  PRODUCT_ITEM_1: 'product-item-1',
  PRODUCT_ITEM_2: 'product-item-2',
  MATCH_THEME: 'match-theme'
};
export const MAIN_LAYOUT_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.mainLayout_Option1',
    value: MAIN_LAYOUT_VALUE.PRODUCT_ITEM_1
  },
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.mainLayout_Option2',
    value: MAIN_LAYOUT_VALUE.PRODUCT_ITEM_2
  }
];

export const SUB_LAYOUT_VALUE = {
  SUB_LAYOUT_1_1: 'subLayout_1_1', // Do not modify -> this value is for 'themeName' in db
  SUB_LAYOUT_1_2: 'subLayout_1_2',
  SUB_LAYOUT_1_3: 'subLayout_1_3',
  SUB_LAYOUT_1_4: 'subLayout_1_4',
  SUB_LAYOUT_2_1: 'subLayout_2_1',
  SUB_LAYOUT_2_2: 'subLayout_2_2',
  SUB_LAYOUT_2_3: 'subLayout_2_3',
  SUB_LAYOUT_2_4: 'subLayout_2_4',
  SUB_LAYOUT_2_5: 'subLayout_2_5',
  SUB_LAYOUT_2_6: 'subLayout_2_6',
  SUB_LAYOUT_2_7: 'subLayout_2_7',
  SUB_LAYOUT_2_8: 'subLayout_2_8',
  SUB_LAYOUT_8_1: 'subLayout_8_1',
  SUB_LAYOUT_4: 'subLayout_4',
  SUB_LAYOUT_6: 'subLayout_6',
  SUB_LAYOUT_7: 'subLayout_7',
  SUB_LAYOUT_5: 'subLayout_5',
  SUB_LAYOUT_8: 'subLayout_8_2',
  SUB_LAYOUT_BULK: 'subLayout_bulk'
};
export const SUB_LAYOUT_OPTIONS = {
  [MAIN_LAYOUT_VALUE.PRODUCT_ITEM_1]: [
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option1_1',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_1_1,
      sample: SubLayout11
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option1_2',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_1_2,
      sample: SubLayout12
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option1_3',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_1_3,
      sample: SubLayout13
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option1_4',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_1_4,
      sample: SubLayout14
    }
  ],
  [MAIN_LAYOUT_VALUE.PRODUCT_ITEM_2]: [
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_1',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_1,
      sample: SubLayout21
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_2',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_2,
      sample: SubLayout22
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_3',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_3,
      sample: SubLayout23
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_4',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_4,
      sample: SubLayout24
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_5',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_5,
      sample: SubLayout25
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_6',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_6,
      sample: SubLayout26
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_7',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_7,
      sample: SubLayout27
    },
    {
      label: 'AdminHTML.ThemeSetting.LayoutModal.subLayout_Option2_8',
      value: SUB_LAYOUT_VALUE.SUB_LAYOUT_2_8,
      sample: SubLayout28
    }
  ]
};

export const COLLECTION_HEADER_VALUE = {
  COLLECTION_HEADER_1: 1,
  COLLECTION_HEADER_2: 2,
  COLLECTION_HEADER_3: 3,
  COLLECTION_HEADER_4: 4
};
export const COLLECTION_HEADER_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.chooseLayout_Option',
    value: COLLECTION_HEADER_VALUE.COLLECTION_HEADER_1,
    sample: CollectionHeader1
  },
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.chooseLayout_Option',
    value: COLLECTION_HEADER_VALUE.COLLECTION_HEADER_2,
    sample: CollectionHeader2
  },
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.chooseLayout_Option',
    value: COLLECTION_HEADER_VALUE.COLLECTION_HEADER_3,
    sample: CollectionHeader3
  },
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.chooseLayout_Option',
    value: COLLECTION_HEADER_VALUE.COLLECTION_HEADER_4,
    sample: CollectionHeader4
  }
];

export const PRODUCT_IMAGE_THUMBNAIL_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.quickView_ProductImage_Thumbnail_Item2',
    value: 'topLeft'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.quickView_ProductImage_Thumbnail_Item1',
    value: 'bottomCenter'
  }
];

export const OVERALL_BUTTON_SHAPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Shape_Option3',
    value: 'rectangle'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.button_Overall_Shape_Option4',
    value: 'round'
  }
];
export const VIEW_AS_LIST_TYPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option1',
    value: '2,3,4columns'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option2',
    value: '2,3,4,5,6columns'
  },
  { label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option3', value: 'grid/list' },
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option4',
    value: '2,3,4columns/list'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option5',
    value: '2,3,4,5,6columns/list'
  }
];

export const VIEW_AS_LIST_TYPE_OPTIONS_SHRINK = [
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option1',
    value: '2,3,4columns'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option2',
    value: '2,3,4,5,6columns'
  }
];

export const VIEW_AS_OPTIONS_BY_THEME = {
  default: VIEW_AS_LIST_TYPE_OPTIONS,
  warehouse: VIEW_AS_LIST_TYPE_OPTIONS,
  empire: VIEW_AS_LIST_TYPE_OPTIONS,
  expanse: VIEW_AS_LIST_TYPE_OPTIONS,
  prestige: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  dawn: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  impulse: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  symmetry: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  motion: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  streamline: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  broadcast: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  focal: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  venue: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  blockshop: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  flow: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  testament: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK,
  horizon: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK
};

export const PRODUCT_COUNT_TEXT_DESCRIPTION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ProductCount_TextDescription_Option1',
    value: '{{count}} products'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ProductCount_TextDescription_Option2',
    value: 'Showing {{from}} - {{to}} of {{total}} products'
  }
];

export const TOOL_BAR_LAYOUT_OPTIONS = {
  1: [
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option1', value: '1_1' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option2', value: '1_2' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option3', value: '1_3' }
  ],
  2: [
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option4', value: '2_1' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option5', value: '2_2' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option6', value: '2_3' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option7', value: '2_4' }
  ],
  3: [
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option8', value: '3_1' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option9', value: '3_2' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option10', value: '3_3' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option11', value: '3_4' }
  ],
  4: [
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option12', value: '4_1' },
    { label: 'AdminHTML.ThemeSetting.Form.toolBar_Layout_Option13', value: '4_2' }
  ]
};
export const PAGE_LAYOUT_TYPE_OPTIONS = [
  { label: 'AdminHTML.ThemeSetting.Form.productList_LayoutType_Option1', value: 'box' },
  { label: 'AdminHTML.ThemeSetting.Form.productList_LayoutType_Option2', value: 'full-width' }
];
export const PAGINATION_TYPE = {
  PAGE_LINKS: 'default',
  LOAD_MORE: 'load_more',
  INFINITE_SCROLL: 'infinite_scroll'
};

export const PAGINATION_TYPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_PaginationType_Option1',
    value: PAGINATION_TYPE.PAGE_LINKS
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_PaginationType_Option2',
    value: PAGINATION_TYPE.LOAD_MORE
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_PaginationType_Option3',
    value: PAGINATION_TYPE.INFINITE_SCROLL
  }
];

export const PAGINATION_TEXT_DESCRIPTION_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_TextDescription_Option1',
    value: 'Showing {{from}} - {{to}} of {{total}} products'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_TextDescription_Option2',
    value: `You're viewing {{from}} - {{to}} of {{total}} products`
  }
];

export const PAGINATION_PRODUCT_COUNT_POSITION_OPTIONS = [
  { label: 'AdminHTML.ThemeSetting.Form.pagination_ProductCountPosition_Item1', value: 'top' },
  { label: 'AdminHTML.ThemeSetting.Form.pagination_ProductCountPosition_Item2', value: 'bottom' }
];

export const NUMBER_SHAPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_PageNumberStyle_NumberShape_Option1',
    value: 'circle'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_PageNumberStyle_NumberShape_Option2',
    value: 'square'
  }
];

export const BUTTON_STYLE_TYPE = {
  TEXT_ONLY: 'text-only',
  TEXT_WITH_ICON: 'text-with-icon',
  ICON_ONLY: 'icon-only'
};

export const BUTTON_STYLE_TYPE_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonType_Option1',
    value: BUTTON_STYLE_TYPE.TEXT_ONLY
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonType_Option2',
    value: BUTTON_STYLE_TYPE.TEXT_WITH_ICON
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonType_Option3',
    value: BUTTON_STYLE_TYPE.ICON_ONLY
  }
];

export const BUTTON_STYLE_SHAPE_OPTIONS_1 = [
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonShape_Option1',
    value: 'circle'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonShape_Option2',
    value: 'square'
  }
];

export const BUTTON_STYLE_SHAPE_OPTIONS_2 = [
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonShape_Option3',
    value: 'rectangle'
  },
  {
    label: 'AdminHTML.ThemeSetting.Form.pagination_ButtonStyle_ButtonShape_Option4',
    value: 'rounded-rectangle'
  }
];

export const MIN_FONT_SIZE = 10;
export const MAX_FONT_SIZE = 30;
export const MAX_FONT_SIZE_PAGINATION = 16;
export const MAX_FONT_SIZE_COLLECTION_TITLE = 60;
export const DEFAULT_FONT_SIZE = 10;
export const MAX_ELEMENT_PER_AREA = 3;
export const MIN_THRESHOLD = 0;
export const MAX_THRESHOLD = 100;
export const MAX_FILE_SIZE = 2000000; // 2MB
export const ACCEPT_FILE_IMAGE_TYPE = 'image/png, image/jpeg, image/jpg, image/svg+xml, image/gif';

export const SIDEBAR_MENU = {
  STYLE: 'style',
  PRODUCT_ITEM: 'product-item',
  PRODUCT_LIST: 'product-list',
  ADVANCED_SETTINGS: 'advanced-settings',
  CODE_EDITOR: 'code-editor',
  SMART_STYLING: 'smart-styling'
};

export const SORT_TEMPLATES_OPTIONS = [
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.pageTemplates_SortAZ',
    value: 'asc'
  },
  {
    label: 'AdminHTML.ThemeSetting.LayoutModal.pageTemplates_SortZA',
    value: 'desc'
  }
];

export const getTemplateImage = themeName => {
  return {
    thumbnail: `https://boost-cdn-prod.bc-solutions.net/template/${themeName}.png`,
    desktop: `https://boost-cdn-prod.bc-solutions.net/template/${themeName}-desktop.jpg`,
    mobile: `https://boost-cdn-prod.bc-solutions.net/template/${themeName}-mobile.png`
  };
};

export const THEME_NAME = {
  DEFAULT: 'default',
  DAWN: 'dawn',
  IMPULSE: 'impulse',
  WAREHOUSE: 'warehouse',
  SYMMETRY: 'symmetry',
  PRESTIGE: 'prestige',
  EXPANSE: 'expanse',
  EMPIRE: 'empire',
  FOCAL: 'focal',
  BROADCAST: 'broadcast',
  MOTION: 'motion',
  VENUE: 'venue',
  TESTAMENT: 'testament',
  FLOW: 'flow',
  BLOCKSHOP: 'blockshop',
  STREAMLINE: 'streamline',
  HORIZON: 'horizon',
};

export const MAPPING_THEME_NAME = {
  dawn: 'basic',
  warehouse: 'wave tech',
  empire: 'epic',
  impulse: 'iconic',
  prestige: 'prime',
  symmetry: 'summer',
  expanse: 'elegance',
  streamline: 'simplify',
  motion: 'movement',
  broadcast: 'boundless',
  flow: 'flavor',
  blockshop: 'blush',
  venue: 'vista',
  focal: 'famous',
  testament: 'timeless',
  horizon: 'haven',
  default: 'default'
};

// Shopify integration settings

export const MENU_ITEM_VALUE = {
  COLOR: 'color',
  ADVANCED_COLOR: 'advanced-color',
  TYPOGRAPHY: 'typography',
  TYPOGRAPHY_HEADING: 'typography-heading',
  TYPOGRAPHY_BODY: 'typography-body',
  TYPOGRAPHY_BUTTON: 'typography-button',
  TYPOGRAPHY_LINK_ACCENT: 'typography-link-accent',

  PRODUCT_ITEM_LAYOUT: 'product-item-layout',
  PRODUCT_ITEM_LABEL: 'product-item-label',
  PRODUCT_ITEM_PRICE: 'product-item-price',
  PRODUCT_ITEM_SWATCHES: 'product-item-swatches',
  PRODUCT_ITEM_ADDITIONAL_INFO: 'product-item-additional-info',
  PRODUCT_ITEM_CALL_TO_ACTION: 'product-item-call-to-action',
  PRODUCT_ITEM_INVENTORY_STATUS: 'product-item-inventory-status',

  PRODUCT_LIST_LAYOUT: 'product-list-layout',
  PRODUCT_LIST_COLLECTION_HEADER: 'product-list-collection-header',
  PRODUCT_LIST_BREADCRUMBS: 'product-list-breadcrumbs',
  PRODUCT_LIST_TOOLBAR: 'product-list-toolbar',
  PRODUCT_LIST_PAGINATION: 'product-list-pagination',

  ADVANCED_SETTINGS_QUICK_VIEW: 'advanced-settings-quick-view',
  ADVANCED_SETTINGS_AJAX_CART: 'advanced-settings-ajax-cart'
};

export const MENU_STYLES_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.colors',
    value: MENU_ITEM_VALUE.COLOR
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.typography',
    value: MENU_ITEM_VALUE.TYPOGRAPHY
  }
];

export const MENU_PRODUCT_ITEM_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.layout',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_LAYOUT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.productLabel',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_LABEL
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.productPrice',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_PRICE
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.swatches',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_SWATCHES
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.inventoryStatus',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_INVENTORY_STATUS
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.callToAction',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_CALL_TO_ACTION
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.additionalInfo',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_ADDITIONAL_INFO
  }
];

export const MENU_PRODUCT_ITEM_OPTIONS_OLD = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.layout',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_LAYOUT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.productLabel',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_LABEL
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.additionalInfo',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_ADDITIONAL_INFO
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.productPrice',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_PRICE
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.swatches',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_SWATCHES
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.callToAction',
    value: MENU_ITEM_VALUE.PRODUCT_ITEM_CALL_TO_ACTION
  }
];

export const MENU_PRODUCT_LIST_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.layout',
    value: MENU_ITEM_VALUE.PRODUCT_LIST_LAYOUT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.collectionHeader',
    value: MENU_ITEM_VALUE.PRODUCT_LIST_COLLECTION_HEADER
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.breadcrumbs',
    value: MENU_ITEM_VALUE.PRODUCT_LIST_BREADCRUMBS
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.toolbar',
    value: MENU_ITEM_VALUE.PRODUCT_LIST_TOOLBAR
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.pagination',
    value: MENU_ITEM_VALUE.PRODUCT_LIST_PAGINATION
  }
];

export const MENU_ADVANCED_SETTINGS_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.quickView',
    value: MENU_ITEM_VALUE.ADVANCED_SETTINGS_QUICK_VIEW
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.cartSetting',
    value: MENU_ITEM_VALUE.ADVANCED_SETTINGS_AJAX_CART
  }
];

export const MENU_TYPOGRAPHY = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.typography_Heading',
    value: MENU_ITEM_VALUE.TYPOGRAPHY_HEADING,
    keyValue: 'headings'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.typography_Body',
    value: MENU_ITEM_VALUE.TYPOGRAPHY_BODY,
    keyValue: 'body'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.typography_Button',
    value: MENU_ITEM_VALUE.TYPOGRAPHY_BUTTON,
    keyValue: 'buttons'
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Setting.typography_LinkAccent',
    value: MENU_ITEM_VALUE.TYPOGRAPHY_LINK_ACCENT,
    keyValue: 'linkAccent'
  }
];

// Find key name of elements without concerning about where those elements are
export const ELEMENT_KEY_NAME = {
  SALE_LABEL: 'productSaleLabel',
  SOLD_OUT_LABEL: 'productSoldOutLabel',
  CUSTOM_BY_TAG_LABEL: 'productCustomLabelByTag',
  SWATCH_1: 'swatches-1',
  SWATCH_2: 'swatches-2',
  SWATCH_3: 'swatches-3',
  ADD_TO_CART_BUTTON: 'selectOptionBtn',
  QUICK_VIEW_BUTTON: 'qvBtn',
  RATING: 'rating',
  WISHLIST: 'wishlist'
};

export const MAP_COLOR_NAME = {
  [ELEMENTS.COLOR_BASE_1]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_BaseColor1',
  [ELEMENTS.COLOR_BASE_2]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_BaseColor2',
  [ELEMENTS.COLOR_BASE_3]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_BaseColor3',
  [ELEMENTS.COLOR_BASE_4]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_BaseColor4',
  [ELEMENTS.COLOR_BASE_5]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_BaseColor5',
  [ELEMENTS.ACCENT_BASE_1]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_AccentColor1',
  [ELEMENTS.ACCENT_BASE_2]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_AccentColor2',
  [ELEMENTS.ACCENT_BASE_3]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_AccentColor3',
  [ELEMENTS.ACCENT_BASE_4]: 'AdminHTML.ShopifyIntegrationSettings.Form.colors_AccentColor4'
};

export const ADVANCED_COLOR_TEXT = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Text_Heading',
    elementKey: ELEMENTS.ADVANCED_COLOR_TEXT_HEADING
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Text_LabelText',
    elementKey: ELEMENTS.ADVANCED_COLOR_TEXT_SUBTITLE
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Text_BodyText',
    elementKey: ELEMENTS.ADVANCED_COLOR_TEXT_BODY_TEXT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Text_SecondaryText',
    elementKey: ELEMENTS.ADVANCED_COLOR_TEXT_SECONDARY_TEXT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Text_LinkActions',
    elementKey: ELEMENTS.ADVANCED_COLOR_TEXT_LINK_ACTIONS
  }
];

export const ADVANCED_COLOR_PRICE = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Price_Product',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_PRODUCT_PRICE
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Price_Sale',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_SALE_PRICE
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Price_Compare',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_COMPARE_AT_PRICE
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Price_SavingText',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_SAVING_TEXT_PRICE
  }
];

export const ADVANCED_COLOR_BUTTON = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Button_Background',
    elementKey: ELEMENTS.ADVANCED_COLOR_BUTTON_BACKGROUND
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Button_Text',
    elementKey: ELEMENTS.ADVANCED_COLOR_BUTTON_TEXT
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Button_Outline',
    elementKey: ELEMENTS.ADVANCED_COLOR_BUTTON_OUTLINE
  }
];

export const ADVANCED_COLOR_OTHERS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Others_SaleLabelBg',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_SALE_LABEL
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Others_SoldOutLabel',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_SOLD_OUT_LABEL
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.advancedColors_Others_CustomByTagLabel',
    elementKey: ELEMENTS.ADVANCED_COLOR_OTHER_CUSTOM_BY_TAG_LABEL
  }
];

export const FONT_FAMILY_INHERIT = 'inherit';

export const VIEW_AS_LIST_TYPE_OPTIONS_V2 = [
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option1',
    value: '2,3,4columns'
  },
  { label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option3', value: 'grid/list' },
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option4',
    value: '2,3,4columns/list'
  }
];

export const VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2 = [
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option1',
    value: '2,3,4columns'
  }
];

// only for Prestige
export const VIEW_AS_LIST_TYPE_OPTIONS_346_COL = [
  {
    label: 'AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Option6',
    value: '3,4,6columns'
  }
];

export const VIEW_AS_OPTIONS_BY_THEME_V2 = {
  [THEME_NAME.DEFAULT]: VIEW_AS_LIST_TYPE_OPTIONS_V2,
  [THEME_NAME.DAWN]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.IMPULSE]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.WAREHOUSE]: VIEW_AS_LIST_TYPE_OPTIONS_V2,
  [THEME_NAME.SYMMETRY]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.PRESTIGE]: VIEW_AS_LIST_TYPE_OPTIONS_346_COL,
  [THEME_NAME.EMPIRE]: VIEW_AS_LIST_TYPE_OPTIONS_V2,
  [THEME_NAME.EXPANSE]: VIEW_AS_LIST_TYPE_OPTIONS_V2,
  [THEME_NAME.FOCAL]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.BROADCAST]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.FLOW]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.MOTION]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.VENUE]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.TESTAMENT]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.BLOCKSHOP]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.STREAMLINE]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2,
  [THEME_NAME.HORIZON]: VIEW_AS_LIST_TYPE_OPTIONS_SHRINK_V2
};

export const CALL_TO_ACTION_POSITION_VERTICAL = [
  { label: 'AdminHTML.ShopifyIntegrationSettings.Common.top', value: 'top' },
  { label: 'AdminHTML.ShopifyIntegrationSettings.Common.bottom', value: 'bottom' }
];

export const CALL_TO_ACTION_POSITION_HORIZONTAL = [
  { label: 'AdminHTML.ShopifyIntegrationSettings.Common.left', value: 'left' },
  { label: 'AdminHTML.ShopifyIntegrationSettings.Common.right', value: 'right' }
];

export const PRODUCT_RATING_DISPLAY_VALUE = {
  ALWAYS_SHOW: 'always',
  SHOW_ON_HOVER: 'on-hover'
};
export const PRODUCT_RATING_DISPLAY_OPTIONS = [
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productRating_DisplayOption_AlwaysShow',
    value: PRODUCT_RATING_DISPLAY_VALUE.ALWAYS_SHOW
  },
  {
    label: 'AdminHTML.ShopifyIntegrationSettings.Form.productRating_DisplayOption_ShowOnHover',
    value: PRODUCT_RATING_DISPLAY_VALUE.SHOW_ON_HOVER
  }
];

export const WHITELIST_THEME_INVENTORY_STATUS = [
  THEME_NAME.DEFAULT,
  THEME_NAME.WAREHOUSE,
  THEME_NAME.SYMMETRY,
  THEME_NAME.EMPIRE,
  THEME_NAME.FOCAL
];
